import axios from "axios";

// Always call the API on the current host. All first-party hosts
// (lobby.afrontcompany.com, diary-stage.emergent.host, preview) route /api
// to the backend via ingress, so same-origin avoids needless CORS and keeps
// HttpOnly cookies intact.
export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

const TOKEN_KEY = "the-lobby-token";

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

// inject Bearer token if we have one stored (cookie auth still works on its own)
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
